import { translations } from 'i18n';

import { useSelector } from '.';

export type Language = 'se' | 'en' | 'es';

export type i18nProps = (obj?: any | null | string, ...params: string[]) => string;

type useI18nProps = () => {
  t: i18nProps;
  BOLanguage: Language;
  defaultLanguage?: string;
  validate: (key: string) => boolean;
};

const useI18n: useI18nProps = () => {
  const storedLang: string | undefined = useSelector((state) => state.BOLanguage);
  const defaultLanguage = useSelector((state) => state.companyData?.defaultLanguage);

  // Ensure BOLanguage is one of the allowed values or default to 'en'
  const BOLanguage: Language = ['se', 'en', 'es'].includes(storedLang as Language)
    ? (storedLang as Language)
    : 'en';

  const getTranslate = (translatedString: any) => {
    if (BOLanguage && translatedString[BOLanguage]) {
      return translatedString[BOLanguage];
    }

    const keys = Object.keys(translatedString);
    for (let i = 0; i < keys.length; i += 1) {
      if (translatedString[keys[i]] && keys[i] !== 'id' && keys[i] !== '__typename') {
        return translatedString[keys[i]];
      }
    }
    return '';
  };

  const t: i18nProps = (obj, ...params) => {
    if (!obj || !BOLanguage) {
      return '';
    }

    if (typeof obj === 'object') {
      return getTranslate(obj);
    }

    if (!translations[obj]) {
      return obj;
    }

    const text: any = translations[obj][BOLanguage];
    if (text) {
      if (typeof text === 'string') {
        return text;
      }
      const formattedText = text(...params);
      return formattedText.includes(undefined) ? '' : formattedText;
    }
    console.log('Missing translation', obj);
    return `Missing translation: [${obj}]`;
  };

  const validate = (key: string) => {
    return Boolean(translations[key]);
  };

  return { t, BOLanguage, defaultLanguage, validate };
};

export default useI18n;
